import React from 'react'
import * as styles from './index.module.css'
import Video from '../Video'

const CareerVideo = ({ nodeLocale, video_ref }) => {
  const videoId = video_ref && video_ref.videoId
  const videoPlaylistId = video_ref && video_ref.videoPlaylistId
  const videoUrl = video_ref && video_ref.videoUrl
  const videoBackgroundImage = video_ref && video_ref.backgroundImage
  const videoAutoplay = video_ref && video_ref.autoplay
  const videoOpts = {
    playerVars: {
      list: videoPlaylistId,
      modestbranding: 1,
      autoplay: videoAutoplay ? 1 : 0,
      rel: 0,
    },
  }
  return (
    <div className="wrapper">
      <div className={styles.container}>
        <Video
          videoId={videoId}
          videoOpts={videoOpts}
          videoUrl={videoUrl}
          videoBackgroundImage={videoBackgroundImage}
          nodeLocale={nodeLocale}
          className={styles.videoPreview}
        />
      </div>
    </div>
  )
}

export default CareerVideo
